import { useMemo } from "react";
import { BaseballTable } from "../../../../components/tables/BaseballTable";
import { getBattingColumns, getPitchingColumns } from "../../../../config/columns";
import {
  getBaserunningColumns,
  getBattedBallBatterColumns,
  getBattedBallPitcherColumns,
  getSituationalBatterColumns,
  getSituationalPitcherrColumns,
  getSplitsBatterColumns,
  getSplitsPitcherColumns,
  getValueBatterColumns,
  getValuePitcherColumns,
} from "../../../../config/leaderboards";

const stripRank = (cols) => cols.filter((c) => c.name !== "#");
const unlink = (cols) =>
  cols.map((c) => (c.name === "Player" ? { ...c, cell: undefined } : c));

const COLUMN_MAP = {
  batting: () => getBattingColumns(true),
  pitching: () => getPitchingColumns(true),
  baserunning: () => unlink(stripRank(getBaserunningColumns)),
  batted_ball: () => unlink(stripRank(getBattedBallBatterColumns)),
  batted_ball_pitcher: () => unlink(stripRank(getBattedBallPitcherColumns)),
  situational: () => unlink(stripRank(getSituationalBatterColumns)),
  situational_pitcher: () => unlink(stripRank(getSituationalPitcherrColumns)),
  splits: () => unlink(stripRank(getSplitsBatterColumns)),
  splits_pitcher: () => unlink(stripRank(getSplitsPitcherColumns)),
  value: () => unlink(stripRank(getValueBatterColumns)),
  value_batter: () => unlink(stripRank(getValueBatterColumns)),
  value_pitcher: () => unlink(stripRank(getValuePitcherColumns)),
};

export const StatTable = (props) => {
  const { stats, type } = props;
  const columns = useMemo(() => {
    const getColumns = COLUMN_MAP[type];
    return getColumns ? getColumns() : [];
  }, [type]);

  return (
    <BaseballTable
      data={stats}
      columns={columns}
      filename={`player_${type}_stats.csv`}
      defaultSortFieldId="year"
      defaultSortAsc={false}
    />
  );
};
